var _style, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:1.68;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:1.68;stroke-miterlimit:10;}\r\n\t.st4{opacity:0.6314;}\r\n\t.st5{opacity:0.9804;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:1.68;stroke-linecap:square;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.85,20.91l-1.2-1.46c-0.13-0.16-0.02-0.41,0.19-0.41h2.4c0.21,0,0.33,0.25,0.19,0.41l-1.2,1.46 C22.14,21.03,21.95,21.03,21.85,20.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85,5.01l-1.2,1.46c-0.13,0.16-0.02,0.41,0.19,0.41h2.4c0.21,0,0.33-0.25,0.19-0.41l-1.2-1.46 C22.14,4.89,21.95,4.89,21.85,5.01z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.32,4.32v17.36H1.68V4.32H24.32 M25,2.64H1c-0.55,0-1,0.45-1,1v18.72c0,0.55,0.45,1,1,1h24c0.55,0,1-0.45,1-1V3.64 C26,3.09,25.55,2.64,25,2.64L25,2.64z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.09,
    y: 3.51,
    width: 1.68,
    height: 18.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.56,18L21.54,8c0-0.14,0.11-0.25,0.25-0.25l0.49,0c0.14,0,0.25,0.11,0.25,0.25L22.54,18c0,0.14-0.11,0.25-0.25,0.25 l-0.49,0C21.67,18.25,21.56,18.14,21.56,18z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIframe);
export default __webpack_public_path__ + "static/media/Iframe.f827612236f875f409f79f8e63e15987.svg";
export { ForwardRef as ReactComponent };